<template>
  <div class="container personality-mobile-bg-gray py-5 mt-4">
    <form>
      <div class="table-responsive">
        <table class="table table-mobile no-wrap">
          <tbody>
            <tr>
              <th class="border-top-0">No.</th>
              <th class="border-top-0 question">{{ trans('test.table_column_questions') }}</th>
              <th class="border-top-0">1</th>
              <th class="border-top-0">2</th>
              <th class="border-top-0">3</th>
              <th class="border-top-0">4</th>
              <th class="border-top-0">5</th>
            </tr>
            <tr
              :class="{ 'table-danger': $v.questions.$each[arraying(index)].$error }"
              v-for="(question, index) in paginatedData"
              :key="question.id"
            >
              <td>{{ numbering(index) | formatNumber }}</td>
              <td>{{ question.question }}</td>
              <td>
                <div class="form-check">
                  <input v-model="question.answer" class="form-check-input" type="radio" value="1" />
                </div>
              </td>
              <td>
                <div class="form-check">
                  <input v-model="question.answer" class="form-check-input" type="radio" value="2" />
                </div>
              </td>
              <td>
                <div class="form-check">
                  <input v-model="question.answer" class="form-check-input" type="radio" value="3" />
                </div>
              </td>
              <td>
                <div class="form-check">
                  <input v-model="question.answer" class="form-check-input" type="radio" value="4" />
                </div>
              </td>
              <td>
                <div class="form-check">
                  <input v-model="question.answer" class="form-check-input" type="radio" value="5" />
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="row align-items-center mt-5">
        <div class="col-lg-6">
          <div class="form-group">
            <label for="test-progress" class="font-weight-bold">{{ trans('test.test_progress') }}</label>
            <div class="progress">
              <div
                class="progress-bar progress-bar-striped progress-bar-animated bg-primary"
                id="test-progress"
                role="progressbar"
                :aria-valuenow="currentProgress"
                aria-valuemin="0"
                aria-valuemax="100"
                :style="currentProgress"
              ></div>
            </div>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="mobile-personality-button d-flex justify-content-end">
            <button
              type="button"
              class="btn btn-outline-primary mr-3"
              @click="prevPage"
              :disabled="pageNumber == 0"
              v-if="pageNumber > 0"
            >
              <i class="fa fa-arrow-left mr-3"></i>
              {{ trans('test.prev') }}
            </button>

            <button
              type="button"
              class="btn btn-primary mr-3"
              @click="nextPage"
              :disabled="pageNumber >= pageCount - 1"
              v-if="pageNumber < pageCount -1"
            >
              <i class="fa fa-arrow-right mr-3"></i>
              {{ trans('test.next') }}
            </button>

            <button
              type="button"
              class="btn btn-success"
              v-if="pageNumber >= pageCount - 1 && load"
              @click="submit"
            >
              <i class="fa fa-save mr-3"></i>
              {{ trans('test.submit') }}
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
var numeral = require("numeral");

Vue.filter("formatNumber", function (value) {
  return numeral(value).format("00");
});

import { required } from "vuelidate/lib/validators";

export default {
  data() {
    return this.initData();
  },
  mounted() {
    this.loadQuestion();
  },
  validations: {
    questions: {
      $each: {
        answer: {
          required,
        },
      },
    },
  },
  methods: {
    initData() {
      return {
        questions: null,
        pageNumber: 0,
        size: 10,
        load: false,
      };
    },
    async submit() {
      let loader = this.$loading.show();
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.errorPopup("Please answer all question.");
        loader.hide();
      } else {
        try {
          const { data } = await axios.post(route("api.saveResult"), {
            questions: this.questions,
          });
          window.location.href = route("en.result");
        } catch (e) {
          loader.hide();
          this.errorPopup(e);
        }
      }
    },
    async loadQuestion() {
      let loader = this.$loading.show();
      try {
        var routeQuestion = "";
        if (window.current_lang == "en") {
          routeQuestion = route("api.en.questions");
        } else {
          routeQuestion = route("api.ms.questions");
        }

        const { data } = await axios.get(routeQuestion);
        this.questions = data.data;
        this.load = true;
        loader.hide();
      } catch (e) {
        this.errorPopup(e);
      }
    },
    nextPage() {
      this.pageNumber++;
    },
    prevPage() {
      this.pageNumber--;
    },
    numbering(index) {
      return index + 1 + this.pageNumber * this.size;
    },
    arraying(index) {
      return index + this.pageNumber * this.size;
    },
  },
  computed: {
    currentProgress() {
      let i = 0;
      if (this.questions) {
        let m = this.pageNumber + 1;
        i = (m / this.pageCount) * 100;
      }
      return "width:" + i + "%";
    },
    pageCount() {
      if (this.questions) {
        let l = this.questions.length,
          s = this.size;
        return Math.ceil(l / s);
      }
      return 0;
    },
    paginatedData() {
      if (this.questions) {
        const start = this.pageNumber * this.size,
          end = start + this.size;
        return this.questions.slice(start, end);
      }
      return 0;
    },
  },
};
</script>
